import Service from "../service";
// eslint-disable-next-line no-unused-vars
import { domain } from "@/utils/Constants";

const FormAPI = {
  getPlants(data) {
    return Service.get(
      `api/getPlants?community=${data.community_id}&type=${data.type}`,
      {
        headers: { Authorization: `Bearer ${data.token}` },
      }
    );
  },
  getPlantsForProfessor(data) {
    return Service.get(
      `api/getPlantsProfessor?community=${data.community_id}&type=${data.type}`,
      {
        headers: { Authorization: `Bearer ${data.token}` },
      }
    );
  },
  getSearchPlants(data) {
    return Service.get(
      `api/searchPlant?community=0&type=0&searchText=${data.data}`,
      {
        headers: { Authorization: `Bearer ${data.token}` },
      }
    );
  },
  getForm(code) {
    return Service.get(`api/getForm?code=${code}`);
  },
  saveForm(data) {
    return Service.post(
      `/api/plants`,
      { data: data },
      {
        headers: { Authorization: `Bearer ${data.token}` },
      }
    );
  },
  saveTobank(data) {
    return Service.post(
      `/api/saveTobank`,
      { data: data },
      {
        headers: { Authorization: `Bearer ${data.token}` },
      }
    );
  },
  saveEditForm(data) {
    return Service.post(
      `/api/plants`,
      { data: data },
      {
        headers: { Authorization: `Bearer ${data.token}` },
      }
    );
  },
  importExcel(data) {
    return Service.post(`/api/importFileExcel`, data);
  },
  searchBE(data) {
    return Service.post(
      `/api/dashboardBE`,
      { data: data },
      {
        headers: { Authorization: `Bearer ${data.token}` },
      }
    );
  },
  getExportExcel(data) {
    window.open(`${domain}/api/exportExcel?geography=${data.geography}
    &community=${data.community}&
    &plotType=${data.plotType}&
    &category=${data.category}&
    &knowledge=${data.knowledge}&
    &habit=${data.habit}&
    &habitat=${data.habitat}&
    &benefit=${data.benefit}&
    &status=${data.status}&
    &publish=${data.publish}`);
    // return Service.get(
    //   `/api/exportExcel?`,
    //   { data: data },
    //   {
    //     headers: { Authorization: `Bearer ${data.token}` },
    //   }
    // );
  },
  searchFE(data) {
    return Service.post(
      `/api/dashboardFE`,
      { data: data },
      {
        headers: { Authorization: `Bearer ${data.token}` },
      }
    );
  },
  editStatus(data) {
    return Service.post(
      `/api/editStatus`,
      { data: data },
      {
        headers: { Authorization: `Bearer ${data.token}` },
      }
    );
  },
  DeletePlant(id) {
    return Service.delete(`/api/plants/${id}`);
  },
  deleteBulkPlant(data) {
    return Service.post(`/api/deleteBulkPlant`, data, {
      headers: { Authorization: `Bearer ${data.token}` },
    });
  },
  checkAvailableOfPlant(data) {
    return Service.post(
      `/api/checkAvailable`,
      { data: data },
      {
        headers: { Authorization: `Bearer ${data.token}` },
      }
    );
  },
  documentIndex(data) {
    return Service.get(`/api/document?take=${data.take ? data.take : ""}
    &year=${data.year ? data.year : ""}
    &month=${data.month ? data.month : ""}
    &category=${data.category ? data.category : ""}`);
  },
  documentShow(id) {
    return Service.get(`/api/document/${id}`);
  },
  // eslint-disable-next-line no-unused-vars
  documentMain(data) {
    return Service.get(`/api/document_main?page=${data.page}
    &year=${data.year ? data.year : ""}
    &month=${data.month ? data.month : ""}
    &category=${data.category ? data.category : ""}`);
  },
  // eslint-disable-next-line no-unused-vars
  documentCategory(data) {
    return Service.get(`/api/document_category`);
  },
};

export default FormAPI;
